import FrameOrientMgr from "@/Master/FrameOrientMgr";

export enum GameMsgKey {
    //通过父级发送消息到子页面
    game_init_data = 'game_init_data',
    game_sync_data = 'game_sync_data',
    game_back_to_game = 'game_back_to_game',

    game_frame_horizontal = 'game_frame_horizontal',
    game_frame_vertical = 'game_frame_vertical',
    game_frame_orient_update = 'game_frame_orient_update',



    game_frame_load_ok = 'game_frame_load_ok',
    game_unity_load_ok = 'game_unity_load_ok',
    game_wasm_load_ok = 'game_wasm_load_ok',

    //通过桥接判断类型
    game_do_type = 'game_do_type',
}